module.exports = __webpack_public_path__ + "static/media/list_view.b7fc7370.svg";